import { create } from 'zustand';

export const useCurrentMarketplaceStore = create((set, get) => ({
  // État initial
  currentMarketplace: null,

  // Actions
  setCurrentMarketplace: (marketplace) =>
    set({
      currentMarketplace: marketplace,
    }),

  updateCurrentMarketplace: (partialMarketplace) =>
    set({
      currentMarketplace: {
        ...get().currentMarketplace,
        ...partialMarketplace,
      },
    }),

  clearCurrentMarketplace: () => set({ currentMarketplace: null }),

  getCurrentMarketplace: () => get().currentMarketplace,

  isCurrentMarketplaceLoaded: () => get().currentMarketplace !== null,
}));
